import React from 'react';
import clsx from 'clsx';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { createStyles } from './styles';

interface Props {
  productLineId: ProductLineId;
  styles?: string;
}

const ProductLineTitle = ({ productLineId, styles }: Props): JSX.Element => {
  const classes = createStyles();
  return (
    <p className={clsx(classes.productLineNameWrapper, styles)}>
      {PRODUCT_LINES_CONTENT_MAP[productLineId]?.icon('2.4rem')}
      <span className={classes.productLineName}>{PRODUCT_LINES_CONTENT_MAP[productLineId]?.label}</span>
    </p>
  );
};

export default ProductLineTitle;
